import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "as-line-ups" }
const _hoisted_2 = { class: "as-back-green" }
const _hoisted_3 = { class: "as-ground-box" }
const _hoisted_4 = { class: "as-note" }


import type {
  IIncidentStatistic,
} from "~src/interfaces";
import MatchEnum from "~src/enums/MatchEnum";


const __default__ = {};

interface IProps { }


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SquadEmpty',
  setup(__props: any) {



const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "as-mid-circle" }, [
          _createElementVNode("div", { class: "as-mid-inner" })
        ], -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['home', 'away'], (team, key) => {
          return _createElementVNode("div", {
            key: key,
            class: _normalizeClass(["as-w-100 as-half-box", {
          'as-half-box-away': team === 'away',
        }])
          }, _cache[0] || (_cache[0] = [
            _createStaticVNode("<div class=\"as-square2\"><div class=\"as-square1\"></div></div><div class=\"as-w-100\"><div class=\"as-circle\"></div></div><div class=\"as-lineup-players\"></div>", 3)
          ]), 2)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listIncidents), (incident, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "as-note-item"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(incident.icon))),
          _createTextVNode(_toDisplayString(incident.label), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})